import GeoJSON from 'ol/format/GeoJSON';

import { create } from './property';

const readFeatures = ( arrayBuffer ) => {
	const instance = new GeoJSON();
	const text = new TextDecoder().decode( arrayBuffer );
		
	return instance.readFeatures( text );
}

const checkProperty = (properties, key, value) => {
	if( !properties.hasOwnProperty( key ) ) {
		const property = create(key, value);
		property.updateIndex( Object.keys(properties).length ); 
		properties[key] = property;		
	} else {
		properties[key].updateType( value );
	}
}

const getProperties = ( features ) => {	
	const properties = {};	
	
	for( let feature of features ) {
		const featureProperties = feature.getProperties();	
	
		for(let key of Object.keys(featureProperties) ) {
			checkProperty( properties, key, feature.get(key));				
		}		
	}	
	
	return Object.values( properties );
}


const geojson = async (reader) => {
	const buffer = await reader.read();
	const features = readFeatures( buffer );
	return getProperties( features );
}

export {
	geojson
}